import cn from "classnames";

import { CheckIcon } from "@/components/icons/check.icon";
import { CheckmarkThinIcon } from "@/components/icons/checkmarkThin.icon";
import { CloseIcon } from "@/components/icons/close.icon";

export type StatusIconVariant = "check" | "close" | "thinCheck";

export const StatusIcon = ({
  variant,
  srOnlyLabel,
  className,
}: StatusIconProps) => {
  if (variant === "thinCheck") {
    return (
      <span
        className={cn(
          "text-greyscale-headline inline-flex shrink-0 items-start",
          className,
        )}>
        <CheckmarkThinIcon className="block h-6 w-6 shrink-0" />
        <span className="sr-only">{srOnlyLabel}</span>
      </span>
    );
  }

  if (variant === "check") {
    return (
      <span
        className={cn(
          "bg-secondary inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full",
          className,
        )}>
        <CheckIcon className="h-6 w-6 text-white" />
        <span className="sr-only">{srOnlyLabel}</span>
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-700",
        className,
      )}>
      <CloseIcon className="h-6 w-6 text-white" />
      <span className="sr-only">{srOnlyLabel}</span>
    </span>
  );
};

type StatusIconProps = {
  variant: StatusIconVariant;
  srOnlyLabel: string;
  className?: string;
};
